
<template>
  
  <div style="height:100%">
        <slot>
        
        </slot>
        <app-loading :show="showLoading" />
  </div>

</template>

<script>
export default {
  computed: {
    showLoading() {
      return this.$store.state.loading;
    },
  }
}
</script>
